import { render } from "./WizardGroup.vue?vue&type=template&id=178d9f7e&scoped=true"
import script from "./WizardGroup.vue?vue&type=script&lang=js"
export * from "./WizardGroup.vue?vue&type=script&lang=js"

import "./WizardGroup.vue?vue&type=style&index=0&id=178d9f7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178d9f7e"]])

export default __exports__